let scriptjs = require("scriptjs");
import * as path from "path";
import * as _ from "lodash";
import { IQuestionType } from "../../TypesAndIdentifiers";

/**
 * @export
 * @param {string} contentJsPath
 * @returns {IView}
 * makes network request for js file, if not pre-loaded
 */
export default async function getContentLibrary(contentJsPath: string): Promise<void | string> {
    try {
        return await new Promise((resolve) => scriptjs(contentJsPath, resolve));
    } catch (e) {
        return Promise.reject(`${contentJsPath} module not found`);
    }
}

export function getLibFromPath(contentJsPath): any {
    let extension = path.extname(contentJsPath).slice(); // ex: .js
    let libraryName = path.basename(contentJsPath, extension).slice(); // ex. - com.playpower.questionTypes.bsnl.click
    return _.get(window, `${libraryName}.default`);
}
